import request, { BASE_URL } from './request'

/**
 * 获取广告位内容
 * @param {string} positionKey 广告位 key
 * @returns {Promise<Array>} 广告详情列表
 */
export function getAds(positionKey) {
  return request.post('/api/ad/getAds', { positionKey })
}

/**
 * 获取广告位详情列表
 * @param {string} positionKey 广告位 key
 * @returns {Promise<Array>} detailList
 */
export async function fetchAdDetails(positionKey) {
  try {
    const res = await getAds(positionKey)
    const detailList = Array.isArray(res.data) ? res.data : []
    return detailList.map(item => ({
      isShowTag: item.isShowTag,
      turnUrl: item.turnUrl,
      textTip: item.textTip,
      textContent: item.textContent,
      imageUrl: item.imageUrl
    }))
  } catch (e) {
    console.error('广告加载失败', positionKey, e)
    return []
  }
}

/**
 * 拼接图片完整 URL
 * @param {string} url 相对或绝对图片地址
 * @returns {string} 完整 URL
 */
export function resolveAdImage(url) {
  if (!url) return ''
  if (/^https?:\/\//.test(url)) return url
  return BASE_URL + url
}
